import {IPrdictorStore} from "apps/BUDWEISERPOTM/modules/types/store";
import {createSelector} from "reselect";
import {RequestState} from "modules";
import {keyBy} from "lodash";

export const getPlayersStore = (state: IPrdictorStore) => state.players;

export const getPlayers = createSelector(getPlayersStore, (store) => store.players);
export const getPlayersById = createSelector(getPlayers, (players) => keyBy(players, "id"));

export const getPlayerById = createSelector(getPlayers, (players) => (playerID: number) => {
	return players.find((player) => player.id === playerID);
});

export const isPlayersLoaded = createSelector(
	getPlayersStore,
	(store) => store.requestState === RequestState.Received
);
